import React, { useState,useEffect,useRef, useCallback } from 'react';
import { Row, Col } from "react-bootstrap";
import { AnimatePresence,motion } from 'framer-motion';
import useEmblaCarousel from 'embla-carousel-react'

import '../lib/bootstrap.min.css'
import './Main.css';
import './SubPage.css';
import { Padding } from '@mui/icons-material';

const Promo = (props) => {

    const ref = useRef(null);
    const [height,setHeight] = useState(0)
    const [width,setWidth] = useState(0)
    const [prevDisable,setPrevDisable] = useState(false)
    const [nextDisable,setNextDisable] = useState(false)

    const [emblaRef, emblaApi] = useEmblaCarousel()

    const scrollPrev = useCallback(() => {
      if (emblaApi) emblaApi.scrollPrev()
        //setPrevDisable(!emblaApi.canScrollPrev)
        //setNextDisable(!emblaApi.canScrollNext)
    }, [emblaApi])
  
    const scrollNext = useCallback(() => {
      if (emblaApi) emblaApi.scrollNext()
        //setPrevDisable(!emblaApi.canScrollPrev)
        //setNextDisable(!emblaApi.canScrollNext)
    }, [emblaApi])
    const scrolTo = useCallback((index) => {
        if (emblaApi) emblaApi.scrollTo(index)
      }, [emblaApi])

    useEffect(() => {
        setHeight(ref.current.clientHeight);
        setWidth(ref.current.clientWidth);
        console.log(props.guide)
    }, []);

  return (
    <AnimatePresence>
        <Row>
            <Col md={12}>
                <motion.div 
                    ref={ref}
                    className='content-subpage'
                    style={{height:(props.height)+'px'}}
                    initial={{ opacity: 0, marginTop:-50 }}
                    animate={{ opacity: 1, marginTop: 0,  }}
                    exit={{opacity:0, marginTop:300}}
                    transition={{ duration: 1.2, ease: [0.87, 0, 0.13, 1] }}
                >
                    <div className="embla" style={{padding:0}}>
                        <div className="embla__viewport" ref={emblaRef} onFocus={()=>{document.getElementById('next').focus()}}>
                            <div className="embla__container">
                                {props.content.map((content,key)=>(
                                    <div className="embla__slide" key={key} style={{height:props.height, maxWidth:350, margin: 0}}>
                                        <img src={content} style={{width:350, maxHeight:350}} />
                                    </div>
                                ))}
                                {/*<div className="embla__slide" key={props.content.length} style={{height:props.height, margin: '0 20px 0 0'}}>
                                    <img src={props.guide} style={{width:'100%'}} />
                                </div>*/}
                            </div>
                        </div>
                        <div className='embla__nav' style={{width:width}}>
                            <button id='prev' className="embla__prev btnFNB" onClick={scrollPrev} disabled={prevDisable}>
                                &laquo; Prev
                            </button>
                            <button id='next' className="embla__next btnFNB" onClick={scrollNext} disabled={nextDisable}>
                                Next &raquo;
                            </button>
                        </div>
                    </div>

                </motion.div>
            </Col>
        </Row>
    </AnimatePresence>
  )};

export default Promo;


